
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Step, StepContent, StepLabel, Stepper, Typography } from "@mui/material"
import PaperDraggable from "../../../../../../components/PaperDraggable"
import { useMemo, useState } from "react";
import Step01 from "./Step01";
import Step02 from "./Step02";
import { IDataDetalharRecibo } from "../../../../../../types/api/financeiro/detalhar-recibos";

export default function DialogSolicitarCancelamentoRecibo({
    open,
    recibo,
    handleChangeProcesso,
    handleClose
}: DialogSolicitarCancelamentoReciboProps) {

    const [activeStep, setActiveStep] = useState(0);
    const [form, setForm] = useState<TFormState>({
        numRecibo: recibo,
        titulosRelacionados: []
    })

    //funções manipuladoras
    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const handleUpdateForm = (value: TFormState) => {
        setForm(value)
    }

    const setOpenCancelRecibo = (open: boolean) => {
        if (!open) {
            handleClose();
        }
    };

    //valores importantes 
    const steps = useMemo(() => [
        {
            label: 'Informar número do recibo',
            content: <Step01 {...{ form, handleNext, handleUpdateForm, open, handleChangeProcesso }} />
        },
        {
            label: 'Selecionar títulos vinculados',
            content: <Step02 {...{ form, handleBack, setOpenCancelRecibo, open, handleChangeProcesso }} />
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    ], [form, open]);
    //

    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                PaperComponent={PaperDraggable}
                aria-labelledby="draggable-dialog-title"
                scroll="body"
                maxWidth={"md"}
                fullWidth
            >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    Solicitar cancelamento de recibo
                </DialogTitle>

                <DialogContent>
                    <Stepper activeStep={activeStep} orientation="vertical">
                        {steps.map((step, index) => (
                            <Step key={step.label}>
                                <StepLabel
                                    optional={index < activeStep && (
                                        <Typography variant="body2" color="textSecondary">
                                            Número do Recibo: {form.numRecibo}
                                        </Typography>
                                    )}
                                >
                                    <Typography color={activeStep === index ? '#000000' : 'rgba(0, 0, 0, 0.6)'} variant="subtitle1">
                                        {step.label}
                                    </Typography>
                                </StepLabel>
                                <StepContent>
                                    <Box my={2}>{step.content}</Box>
                                </StepContent>
                            </Step>
                        ))}
                    </Stepper>
                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={handleClose}
                    >
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

interface DialogSolicitarCancelamentoReciboProps {
    open: boolean,
    recibo: number,
    handleClose: () => void,
    handleChangeProcesso: (item: string) => void
}

export type TFormState = {
    numRecibo: number,
    titulosRelacionados: IDataDetalharRecibo[]
}
